import { useStyle } from "../style";
import { SvgIcon } from "@mui/material";
import calendarIconImg from "@static/img/icons/calendar.svg";

export const CalendarIcon = () => {
    const { classes } = useStyle({});

    return <SvgIcon className={classes.iconBox} component={calendarIconImg} viewBox="0 0 512 512" />;
};
